import {Inject, inject, Injectable} from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Observable, tap} from 'rxjs';
import {FormTypeEnum} from '../../corporate/enums/form-type.enum';
import {CustomersLoginMsalService} from '../msal/services/customers-login-msal.service';
import {IFormResponse} from '../../corporate/models/IFormResponse';
import {IForm} from '../../corporate/models/IForm';

@Injectable({
  providedIn: 'root'
})
export class CustomersOnboardingService {

  private readonly url = environment.apiConfig.IdentityAPI.endpoint;
  private readonly customerMsalService = inject(CustomersLoginMsalService);


  constructor(
    @Inject('NoInterceptorHttpClient')
    private httpNoInterceptor: HttpClient,
    private httpClient: HttpClient,

  ) {}

  get customerState(): string {
    return localStorage.getItem('customer_state') ? localStorage.getItem('customer_state') : null;
  }

  setCustomerState(value: string): void {
    localStorage.setItem('customer_state', value);
  }

  removeCustomerState(): void {
    localStorage.removeItem('customer_state');
  }

  getStateStringForOnboarding(data: {clientType: number; companyId?: number}): Observable<{stateGuid: string}>{
    data.companyId = 5;
   return this.httpNoInterceptor.post<{stateGuid: string}>(this.url + '/auth/clients/start-registration', data).pipe(
     tap(
       ({stateGuid}) =>
       this.redirectToSignUpPage(data.clientType, stateGuid)
     )
   );
  }

  getCustomerTypeAndId(): Observable<{clientType: number, submittedFormId: number}>{
    return this.httpClient.post<{ clientType: number, submittedFormId: number}>
    (this.url + '/Clients/callback', {
      state: this.customerState
    }).pipe(
      tap(() => this.removeCustomerState())
    );
  }

  submitFormFirstTime(submittedFormId: number): Observable<void>{
    return this.httpClient.patch<void>(this.url + `/Clients/submitted-form/${submittedFormId}`, {});
  }

  redirectToLogin() {
    //this.customerMsalService.redirectToSignUp(5);
  }

  createForm(data, isNominee: boolean, submittedFormId?: number): Observable<IFormResponse> {
    const url = environment.apiConfig.corporateAPI.endpoint;
    let params = new HttpParams();
    let newcompanyId = 5;
    if (submittedFormId) {
      params = params.set('submittedFormId', submittedFormId)
    }
    if (isNominee) {
      params = params.set('isNominee', isNominee)
    }
    return this.httpClient.post<IFormResponse>(`${url}/company/${newcompanyId}?submit=${true}`, data, {
      params: params,
    });
  }

  getFormToEdit(formId: number) {
    let newcompanyId = 5;
    const url = environment.apiConfig.corporateAPI.endpoint;
    return this.httpClient.get(`${url}/company/${newcompanyId}/form/${formId}`);
  }

  getForm(type: number): Observable<IForm> {
    let newcompanyId = 5;
    const url = environment.apiConfig.corporateAPI.endpoint;
    return this.httpClient.get<IForm>(`${url}/company/${newcompanyId}/forms/type/${type}`)
  }

  logout() {
    this.customerMsalService.logout().then(() => {
      window.location.reload();
    });
  }

  private redirectToSignUpPage(clientType: number, state: string) {
    this.setCustomerState(state);
    this.setClientType(clientType);
    //this.customerMsalService.redirectToSignUp(clientType);
  }

  private  setClientType(type: number) {
    switch (type) {
      case FormTypeEnum.Individual:
        return localStorage.setItem('client_type', 'individual')
      case FormTypeEnum.Business:
        return localStorage.setItem('client_type', 'business')
      default:
        return localStorage.setItem('client_type', 'login');
    }
  }
}
